import styled, { css } from 'styled-components';
import theme from 'styled-theming';
import Icon from '../Icon';
var Statistic = styled.div.withConfig({
  displayName: "Statisticstyles__Statistic",
  componentId: "sc-hv3hr8-0"
})(["font-feature-settings:'kern','liga','calt','case','ss03','cv03','cv04','tnum';"]);
var labelColor = theme('mode', {
  light: 'var(--dentsu-color-n700)',
  dark: 'var(--dentsu-color-white)'
});
var labelFontSize = theme('size', {
  small: 'var(--dentsu-font-size-12)',
  medium: 'var(--dentsu-font-size-14)',
  large: 'var(--dentsu-font-size-14)',
  xLarge: 'var(--dentsu-font-size-14)'
});
var labelLineHeight = theme('size', {
  small: 1.2,
  medium: 1.3,
  large: 1.4,
  xLarge: 1.4
});
var Label = styled.div.withConfig({
  displayName: "Statisticstyles__Label",
  componentId: "sc-hv3hr8-1"
})(["color:", ";font-size:", ";font-weight:var(--dentsu-font-weight-regular);line-height:", ";min-height:19px;> div{vertical-align:middle;}"], labelColor, labelFontSize, labelLineHeight);
var TooltipTrigger = styled(Icon).withConfig({
  displayName: "Statisticstyles__TooltipTrigger",
  componentId: "sc-hv3hr8-2"
})(["color:", ";margin-left:4px;vertical-align:unset;"], function (props) {
  return props.mode === 'light' ? 'var(--dentsu-color-n650)' : 'var(--dentsu-color-white)';
});
var Content = styled.div.withConfig({
  displayName: "Statisticstyles__Content",
  componentId: "sc-hv3hr8-3"
})(["", " ", ""], function (props) {
  return props.isInline && props.variant !== 'kpi' && css(["display:flex;align-items:baseline;"]);
}, function (props) {
  return props.isInline && props.variant === 'kpi' && css(["display:flex;align-items:", ";"], theme('size', {
    small: 'center',
    medium: 'center',
    large: 'baseline',
    xLarge: 'baseline'
  }));
});
var valueColor = theme('mode', {
  light: 'var(--dentsu-color-black)',
  dark: 'var(--dentsu-color-white)'
});
var valueFontSize = theme('size', {
  small: 'var(--dentsu-font-size-16)',
  medium: 'var(--dentsu-font-size-24)',
  large: 'var(--dentsu-font-size-32)',
  xLarge: 'var(--dentsu-font-size-42)'
});
var valueFontWeight = theme('size', {
  small: 'var(--dentsu-font-weight-regular)',
  medium: 'var(--dentsu-font-weight-light)',
  large: 'var(--dentsu-font-weight-light)',
  xLarge: 'var(--dentsu-font-weight-light)'
});
var valueLineHeight = theme('size', {
  small: 1.4,
  medium: 1.25,
  large: 1.25,
  xLarge: 1.25
});
var valueMarginRight = theme('size', {
  small: '2px',
  medium: '2px',
  large: '4px',
  xLarge: '4px'
});
var Value = styled.div.withConfig({
  displayName: "Statisticstyles__Value",
  componentId: "sc-hv3hr8-4"
})(["display:flex;align-items:baseline;color:", ";font-size:", ";font-weight:", ";line-height:", ";margin-right:", ";"], valueColor, valueFontSize, valueFontWeight, valueLineHeight, valueMarginRight);
var percentSignFontSize = theme('size', {
  small: 'var(--dentsu-font-size-16)',
  medium: 'var(--dentsu-font-size-24)',
  large: 'var(--dentsu-font-size-24)',
  xLarge: 'var(--dentsu-font-size-28)'
});
var PercentSign = styled.div.withConfig({
  displayName: "Statisticstyles__PercentSign",
  componentId: "sc-hv3hr8-5"
})(["color:", ";font-size:", ";font-weight:", ";line-height:", ";"], valueColor, percentSignFontSize, valueFontWeight, valueLineHeight);
var actionMarginLeft = theme('size', {
  small: '4px',
  medium: '4px',
  large: '6px',
  xLarge: '6px'
});
var Action = styled.div.withConfig({
  displayName: "Statisticstyles__Action",
  componentId: "sc-hv3hr8-6"
})(["display:flex;margin:auto 0 auto ", ";"], actionMarginLeft);

var incrementColor = function incrementColor(props) {
  if (props.variant === 'status' || props.variant === 'kpi') {
    switch (props.status) {
      case 'positive':
        return theme('mode', {
          light: 'var(--dentsu-color-g600)',
          dark: 'var(--dentsu-color-g600)'
        });

      case 'negative':
        return theme('mode', {
          light: 'var(--dentsu-color-r500)',
          dark: 'var(--dentsu-color-r500)'
        });

      default:
        return theme('mode', {
          light: 'var(--dentsu-color-n650)',
          dark: 'var(--dentsu-color-n50)'
        });
    }
  } else {
    return theme('mode', {
      light: 'var(--dentsu-color-n975)',
      dark: 'var(--dentsu-color-n50)'
    });
  }
};

var incrementFontSize = function incrementFontSize(props) {
  if (props.variant === 'recorded') {
    return theme('size', {
      small: 'var(--dentsu-font-size-12)',
      medium: 'var(--dentsu-font-size-16)',
      large: 'var(--dentsu-font-size-24)',
      xLarge: 'var(--dentsu-font-size-28)'
    });
  } else {
    return theme('size', {
      small: 'var(--dentsu-font-size-14)',
      medium: 'var(--dentsu-font-size-16)',
      large: 'var(--dentsu-font-size-18)',
      xLarge: 'var(--dentsu-font-size-20)'
    });
  }
};

var incrementFontWeight = function incrementFontWeight(props) {
  if (props.variant === 'recorded') {
    return theme('size', {
      small: 'var(--dentsu-font-weight-regular)',
      medium: 'var(--dentsu-font-weight-regular)',
      large: 'var(--dentsu-font-weight-light)',
      xLarge: 'var(--dentsu-font-weight-light)'
    });
  } else {
    return 'var(--dentsu-font-weight-semibold)';
  }
};

var incrementLineHeight = theme('size', {
  small: 1.4,
  medium: 1.25,
  large: 1.25,
  xLarge: 1.25
});
var Increment = styled.div.withConfig({
  displayName: "Statisticstyles__Increment",
  componentId: "sc-hv3hr8-7"
})(["display:flex;align-items:center;color:", ";font-size:", ";font-weight:", ";line-height:", ";"], incrementColor, incrementFontSize, incrementFontWeight, incrementLineHeight);
var supportingTextColor = theme('mode', {
  light: 'var(--dentsu-color-n700)',
  dark: 'var(--dentsu-color-white)'
});
var supportingTextFontSize = theme('size', {
  small: 'var(--dentsu-font-size-10)',
  medium: 'var(--dentsu-font-size-12)',
  large: 'var(--dentsu-font-size-12)',
  xLarge: 'var(--dentsu-font-size-12)'
});
var supportingTextLineHeight = theme('size', {
  small: 1.2,
  medium: 1.3,
  large: 1.4,
  xLarge: 1.4
});
var supportingTextMarginTop = theme('size', {
  small: '2px',
  medium: '2px',
  large: '2px',
  xLarge: '2px'
});
var SupportingText = styled.div.withConfig({
  displayName: "Statisticstyles__SupportingText",
  componentId: "sc-hv3hr8-8"
})(["color:", ";font-size:", ";font-weight:var(--dentsu-font-weight-regular);line-height:", ";margin-top:", ";"], supportingTextColor, supportingTextFontSize, supportingTextLineHeight, supportingTextMarginTop);
export var Styled = {
  Action: Action,
  Content: Content,
  Increment: Increment,
  Label: Label,
  Statistic: Statistic,
  SupportingText: SupportingText,
  TooltipTrigger: TooltipTrigger,
  Value: Value,
  PercentSign: PercentSign
};